import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  useMap
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});
L.Marker.prototype.options.icon = DefaultIcon;

const RecenterMap = ({ lat, lng, zoom }) => {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], zoom);
  }, [lat, lng, zoom]);
  return null;
};

const MapClinicas = ({ center, isLoading, clinicas }) => {
  return (
    <div
      className="map-wrapper"
      style={{
        height: "400px",
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        zIndex: 1,
        position: "relative"
      }}
    >
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "rgba(255,255,255,0.8)",
            zIndex: 1000,
            padding: "10px",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold"
          }}
        >
          🔍 Buscando zona...
        </div>
      )}

      <MapContainer
        center={[center.lat, center.lng]}
        zoom={13}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <RecenterMap lat={center.lat} lng={center.lng} zoom={11} />

        {/* Zona de búsqueda (Opcional, ayuda a dar contexto) */}
        {!isLoading && (
          <Circle
            center={[center.lat, center.lng]}
            pathOptions={{
              fillColor: "#2563EB",
              color: "#2563EB",
              opacity: 0.5
            }}
            radius={2000}
          />
        )}

        {/* --- MARKERS --- */}
        {clinicas.map((clinica) => {
          if (!clinica.lat || !clinica.lng) return null;
          return (
            <Marker
              key={clinica.id}
              position={[parseFloat(clinica.lat), parseFloat(clinica.lng)]}
            >
              <Popup minWidth={200}>
                <strong>{clinica.nombre}</strong>
                <br />
                {clinica.direccion}
                <div
                  style={{
                    borderTop: "1px solid #e2e8f0",
                    marginTop: "8px",
                    paddingTop: "8px"
                  }}
                >
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${clinica.lat},${clinica.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#2563EB",
                      textDecoration: "none",
                      fontWeight: "600",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    📍 Cómo llegar (Google Maps)
                  </a>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default MapClinicas;
